interface IApplication {
    globalTextColor: string
}
export const Application: React.FC<IApplication> = ({globalTextColor}) => {
    return (
        <div className={`text-[${globalTextColor}]`}>app</div>
    );
}
